module.exports = __webpack_public_path__ + "img/icon-4.29bf47a0.svg";